import React from 'react';

import RadioButton from './RadioButton';

// Radio input
const RadioGroup = ({
  options,
  ...props
}) => {
  return (
    <div className="RadioGroup">
      {
        options.map(({value, label}) => 
          <RadioButton {...props} key={value} label={label} selectedValue={value} />
        )
      }  
    </div>
   );
};

export default RadioGroup;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/RadioGroup.jsx